import { Component, ViewEncapsulation} from '@angular/core';

/** Container for the two sections of Terminology */
@Component({
    selector: 'pd-admin-terminology-container',
    templateUrl: './admin-terminology-container.component.html',
    styleUrls: ['./admin-terminology-container.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AdminTerminologyContainerComponent {}